(function () {
  var panel = document.getElementById('PredictiveSearch');
  var backdrop = document.getElementById('PredictiveSearchBackdrop');
  var input = document.getElementById('PredictiveSearchInput');
  var results = document.getElementById('PredictiveSearchResults');
  if (!panel || !input || !results) return;

  var debounceTimer;
  var currentController;

  function open() {
    panel.classList.add('is-open');
    backdrop.classList.add('is-visible');
    panel.setAttribute('aria-hidden', 'false');
    window.setTimeout(function () { input.focus(); }, 50);
  }

  function close() {
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
    panel.setAttribute('aria-hidden', 'true');
  }

  function renderResults(data) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (!input.value.trim()) {
      results.innerHTML = '';
      results.classList.remove('is-visible');
      return;
    }

    if (products.length === 0) {
      results.innerHTML = '<p class="pf-predictive-search__empty">Aucun résultat.</p>';
      results.classList.add('is-visible');
      return;
    }

    var html = '<ul class="pf-predictive-search__list">';
    products.forEach(function (product) {
      html +=
        '<li class="pf-predictive-search__item">' +
        '<a href="' + product.url + '" data-testid="predictive-search-result">' +
        (product.image ? '<img src="' + product.image + '" alt="" width="48" height="48" loading="lazy">' : '') +
        '<span class="pf-predictive-search__item-info">' +
        '<span class="pf-predictive-search__item-vendor">' + (product.vendor || '') + '</span>' +
        '<span class="pf-predictive-search__item-title">' + product.title + '</span>' +
        '</span>' +
        '<span class="pf-predictive-search__item-price">' + product.price + '</span>' +
        '</a>' +
        '</li>';
    });
    html += '</ul>';
    html +=
      '<a class="pf-predictive-search__view-all" href="' +
      '/search?type=product&q=' + encodeURIComponent(input.value.trim()) +
      '">Voir tous les résultats</a>';

    results.innerHTML = html;
    results.classList.add('is-visible');
  }

  function search(term) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=6' +
      '&resources[options][fields]=title,vendor,product_type';

    fetch(url, { signal: currentController.signal })
      .then(function (res) { return res.json(); })
      .then(renderResults)
      .catch(function (err) {
        if (err.name !== 'AbortError') results.innerHTML = '';
      });
  }

  input.addEventListener('input', function () {
    window.clearTimeout(debounceTimer);
    var term = input.value.trim();
    if (term.length < 2) {
      results.innerHTML = '';
      results.classList.remove('is-visible');
      return;
    }
    debounceTimer = window.setTimeout(function () { search(term); }, 220);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#SearchToggle')) {
      e.preventDefault();
      open();
    } else if (e.target.closest('#PredictiveSearchClose') || e.target === backdrop) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
  });
})();
